import { BaseHubAvatar } from '~/components/basehub-avatar'
import { useUserData } from '~/hooks-data/use-user-data'
import { makeFullNameFromClerkUser } from '@basehub/data/auth/utils/make-full-name-from-clerk-user'
import { Skeleton } from '~/sotano-kit/primitives/skeleton'
import * as React from 'react'
import Link from 'next/link'

export const TeamMember = ({
  userId,
  linkToPersonalTeam,
}: {
  userId: string
  linkToPersonalTeam: boolean
}) => {
  const userQuery = useUserData(userId)
  const user = userQuery.data

  const item = (
    <li className="flex h-6 items-center last:mb-0">
      {user ? (
        <>
          <BaseHubAvatar
            id={user.id}
            name={makeFullNameFromClerkUser(user) ?? user.username}
            size="small"
            className="mr-2 !border !border-dark-border-solid"
            forceSrc={user.isMe ? (user.imageUrl ?? undefined) : undefined}
          />
          <span className="text-xs leading-4 text-dark-dim">
            {makeFullNameFromClerkUser(user)}
          </span>
          <span className="ml-1 text-xs leading-4 text-dark-faint">
            {user.username}
          </span>
        </>
      ) : (
        <>
          <Skeleton
            className="mr-2 h-4 w-4 !rounded-full"
            width={24}
            height={24}
          />
          <Skeleton className="h-4 w-28 rounded" width={112} height={16} />
        </>
      )}
    </li>
  )

  if (linkToPersonalTeam) {
    return <Link href={`/${user?.username}`}>{item}</Link>
  } else {
    return item
  }
}
